module.exports = __webpack_public_path__ + "img/media-11.ee1f4e1a.png";